<section class="content" id="raindroptoday">
    <div class="card">
        <div class="card-header bg-primary">ปริมาณน้ำฝน วันนี้ {{today}}</div>
        <div class="card-body">
            <table class="table">
                <thead>
                    <th scope="col">โซน</th>
                    <th scope="col">ปริมาณน้ำฝน(วันนี้)</th>
                    <th scope="col">ม.ค.</th>
                    <th scope="col">ก.พ.</th>
                    <th scope="col">มี.ค.</th>
                    <th scope="col">เม.ย.</th>
                    <th scope="col">พ.ค.</th>
                    <th scope="col">มิ.ย.</th>
                    <th scope="col">ก.ค.</th>
                    <th scope="col">ส.ค.</th>
                    <th scope="col">ก.ย.</th>
                    <th scope="col">ต.ค.</th>
                    <th scope="col">พ.ย.</th>
                    <th scope="col">ธ.ค.</th>
                    <th scope="col">ปริมาณน้ำฝนรวม</th>
                    <th scope="col">วันที่ฝนตก</th>
                </thead>
                <tbody>
                    <tr *ngFor="let item of raintoday">
                        <td>{{item.supzone}}</td>
                        <td>{{item.rainfall_today}}</td>
                        <td>{{item.rainfall_1.toLocaleString('ar-TH')}}</td>
                        <td>{{item.rainfall_2.toLocaleString('ar-TH')}}</td>
                        <td>{{item.rainfall_3.toLocaleString('ar-TH')}}</td>
                        <td>{{item.rainfall_4.toLocaleString('ar-TH')}}</td>
                        <td>{{item.rainfall_5.toLocaleString('ar-TH')}}</td>
                        <td>{{item.rainfall_6.toLocaleString('ar-TH')}}</td>
                        <td>{{item.rainfall_7.toLocaleString('ar-TH')}}</td>
                        <td>{{item.rainfall_8.toLocaleString('ar-TH')}}</td>
                        <td>{{item.rainfall_9.toLocaleString('ar-TH')}}</td>
                        <td>{{item.rainfall_10.toLocaleString('ar-TH')}}</td>
                        <td>{{item.rainfall_11.toLocaleString('ar-TH')}}</td>
                        <td>{{item.rainfall_12.toLocaleString('ar-TH')}}</td>
                        <td>{{item.rainfall_sum.toLocaleString('ar-TH')}}</td>
                        <td>{{item.rainy_day}}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</section>